import { render, staticRenderFns } from "./AdminCategories.vue?vue&type=template&id=58e62a5c"
import script from "./AdminCategories.vue?vue&type=script&lang=js"
export * from "./AdminCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58e62a5c')) {
      api.createRecord('58e62a5c', component.options)
    } else {
      api.reload('58e62a5c', component.options)
    }
    module.hot.accept("./AdminCategories.vue?vue&type=template&id=58e62a5c", function () {
      api.rerender('58e62a5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminCategories.vue"
export default component.exports